"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceOfGroup = exports.filterEmptyGroup = void 0;
const activityPriceOfPeriod_1 = require("./activityPriceOfPeriod");
const periods_1 = require("./periods");
function filterEmptyGroup(pricing) {
    return Object.assign(Object.assign({}, pricing), { groups: pricing.groups.filter((group) => group.count > 0) });
}
exports.filterEmptyGroup = filterEmptyGroup;
function priceOfGroup(pricing, pricingPeriods, bookingById, userGroupId, activityDate) {
    const periodName = periods_1.findPeriodName(pricingPeriods, activityDate);
    return activityPriceOfPeriod_1.activityPriceOfPeriod(pricing, bookingById, userGroupId, periodName);
}
exports.priceOfGroup = priceOfGroup;
//# sourceMappingURL=activityPriceOfGroup.js.map